<!-- 由 suu 创建于 2022-06-23 Thursday -->
<template>
  <div class="ques-radio">
    <div class="radio-title">{{ curQues.field_title }}</div>
    <div class="radio-list">
      <div
        class="radio-item"
        :class="[
          curQues.field_unit[index].key == value ? 'radio-item-active' : ''
        ]"
        @click="handelChange(item)"
        v-for="(item, index) in curQues.field_unit"
        :key="item.key || index"
      >
        {{ item.value }}
      </div>
    </div>
    <img class="radio-tips" v-if="curQues.content_url" :src="curQues.content_url"></img>
    <div class="radio-desc" v-else-if="curQues.sub_text">
      {{ curQues.sub_text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ques-radio',

  components: {},

  props: {
    curQues: {}
  },

  data() {
    return {
      value: ''
    }
  },

  computed: {},

  watch: {
    curQues(nv) {
      this.value = nv.value
    }
  },

  created() {
    this.value = this.curQues.value
  },

  mounted() {},

  destroyed() {},

  methods: {
    handelChange(item) {
      this.value = item.key
      const score = item.score || 0
      this.$emit('change', { value: this.value, score })
    }
  }
}
</script>

<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-radio {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .radio-title {
    width: 286px;
    text-align: center;
    box-sizing: border-box;
    font-size: 22px;
    font-weight: 600;
    color: #202539;
    line-height: 32px;
  }
  .radio-list {
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 28px;
    .radio-item {
      margin-bottom: 14px;
      width: 286px;
      background: #ffffff;
      border-radius: 26px;
      padding: vw(15);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      color: #373d52;
      text-align: center;
      line-height: 23px;
    }
    .radio-item-active {
      background: #c9bbff;
      color: #fff;
    }
  }
  .radio-tips {
    width: auto;
    height: 160px;
    position: absolute;
    left: 50%;
    transform: translate(-50%,0%);
    z-index: -1;
    @include fixedBottom();
  }
  .radio-desc {
    width: 286px;
    text-align: center;
    font-size: 12px;
    color: #697387;
    line-height: 21px;
    margin-top: 120px;
  }
}
</style>